//AddNewAddress.tsx
import React, { useEffect, useState } from 'react';
import logo from '../assets/images/logo-1.svg';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useNavigate } from 'react-router-dom';
import MapAddAddress from './MapAddAddress';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Search from "../assets/images/search-image.png";

const AddNewAddress: React.FC<{ updateUserName: (newUserName: string) => void }> = ({ updateUserName }) => {

    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [notificationOpen, setNotificationOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [componentKey, setComponentKey] = useState(0);
    const [userName, setUserName] = useState('');
    const [userProfile, setUserProfile] = useState<UserProfile | null>(null); // Store user profile data
    const [isProfileModalOpen, setIsProfileModalOpen] = useState(false); // Modal visibility state
    const [addressType, setAddressType] = useState<string>('Home');
    const [isCustom, setIsCustom] = useState(false); // State to track if "Other" is selected
    const [formData, setFormData] = useState({
        email: '',
        phoneNumber: '',
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        pinCode: '',
        latitude: '',
        longitude: '',
        blockCode: '',
    });
    interface Errors {
        addressLine1: string;
        addressLine2: string;
        addressLine3: string;
        pinCode: string;
        addressType: string;
        location: string;
    }
    interface PinCodeData {
        pinCode: string;
        blockCode: string;
    }
    const [errors, setErrors] = useState<Errors>({
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        pinCode: '',
        addressType: '',
        location: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [nearbyPinCodes, setNearbyPinCodes] = useState<PinCodeData[]>([]);
    interface UserProfile {
        id: number;
        userName: string;
        email: string;
        phoneNumber: string;
        azureToken: string;
        roleId: number;
        roleName: string;
        createdDate: string;
        updatedDate: string;
        status: string | null;
    }
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;

        // Type assertion to ensure name is a valid key of Errors
        setFormData({ ...formData, [name]: value });

        // Remove the validation message for the field when it is populated
        setErrors((prev) => ({ ...prev, [name as keyof Errors]: value ? '' : prev[name as keyof Errors] }));
    };

    const handleLocationChange = (lat: string, lon: string, pinCode: string, street: string, city: string) => {
        setFormData((prevData) => ({
            ...prevData,
            latitude: lat,
            longitude: lon,
            pinCode: pinCode === 'N/A' ? '' : pinCode,
            addressLine1: '',
            addressLine2: street === 'N/A' ? '' : street,
            addressLine3: city === 'N/A' ? '' : city
        }));

        // Clear related validation messages
        setErrors((prev) => ({
            ...prev,
            location: '', // If location is required
            pinCode: pinCode ? '' : prev.pinCode,
            addressLine1: '',
            addressLine2: street ? '' : prev.addressLine2,
            addressLine3: city ? '' : prev.addressLine3
        }));
    };


    // const handleBackLocation = () => {
    //     setComponentKey(prevKey => prevKey + 1);
    //     setFormData(prevData => ({
    //         ...prevData, // Retain other fields like email, phoneNumber
    //         addressLine1: '',
    //         addressLine2: '',
    //         addressLine3: '',
    //         pinCode: '',
    //         latitude: '',
    //         longitude: '', // Optionally reset location fields
    //     }));
    // }
    const handleAddressTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = e.target.value;

        // If the selected option is "custom", allow typing in the select input
        if (selectedValue === "custom") {
            setIsCustom(true);
            setAddressType(''); // Reset the address type
        } else {
            setIsCustom(false);
            setAddressType(selectedValue); // Update state for predefined options
        }

    };

    const handleCustomAddressTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAddressType(e.target.value); // Update state when user types custom address type
    };

    // const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    //     const { name, value } = e.target;
    //     setFormData({ ...formData, [name]: value });
    //     setErrors((prev) => ({ ...prev, [name]: value ? '' : prev[name as keyof Errors] }));
    // };
    const handlePinCodeChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value.length <= 6) {
            setFormData({
                ...formData,
                pinCode: value
            });
        }
    };
    let infoToastShown = false;

    const handlePinCodeChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedPinCode = e.target.value;
        const selectedPinCodeData = nearbyPinCodes.find(pin => pin.pinCode === selectedPinCode);
        if (selectedPinCodeData) {
            if (selectedPinCodeData.pinCode !== nearbyPinCodes[0].pinCode) {
                if (!toast.isActive('info')) {
                    toast.info('The selected pincode differs from the recommended one.', { toastId: 'info' });
                }
            }

            setFormData({
                ...formData,
                pinCode: selectedPinCodeData.pinCode,
                blockCode: selectedPinCodeData.blockCode
            });
        }
    };





    const fetchNearbyPinCodes = async (latitude: number, longitude: number) => {
        const token = localStorage.getItem('token');
        if (!token) {
            console.error('Token not found in localStorage');
            toast.error('Session expired. Please log in again.');
            return;
        }

        try {
            const response = await fetch(`https://pamsapi.vofoxsolutions.com/api/Address/GetNearbyPinCodesPamCodeAsync?latitude=${latitude}&longitude=${longitude}`
                //const response = await fetch(`http://192.168.7.108:7448/api/Address/GetNearbyPinCodesPamCodeAsync?latitude=${latitude}&longitude=${longitude}`

                , {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });

            if (!response.ok) {
                throw new Error(`Error: ${response.status} ${response.statusText}`);
            }

            const data = await response.json();
            const formattedPinCodes = data.map((item: string) => ({
                pinCode: item.slice(0, 6),
                blockCode: item.slice(6)
            }));
            setNearbyPinCodes(formattedPinCodes);
            if (formattedPinCodes.length > 0) {
                setFormData((prevData) => ({
                    ...prevData,
                    pinCode: formattedPinCodes[0].pinCode,
                    blockCode: formattedPinCodes[0].blockCode // Set the first blockCode from the response
                }));
            }
        } catch (error) {
            console.error('Error fetching pin codes:', error);
        }
    };

    useEffect(() => {
        if (formData.latitude && formData.longitude) {
            fetchNearbyPinCodes(Number(formData.latitude), Number(formData.longitude));
        }
    }, [formData.latitude, formData.longitude]);



    const handleSubmit = async () => {
        if (isSubmitting) return; // Prevent multiple submissions

        // Reset all errors
        setErrors({
            addressLine1: '',
            addressLine2: '',
            addressLine3: '',
            pinCode: '',
            addressType: '',
            location: ''
        });

        let hasErrors = false;

        // Validate all fields
        if (!formData.addressLine1) {
            setErrors(prev => ({ ...prev, addressLine1: 'Building/House Number is required' }));
            hasErrors = true;
        }
        if (!formData.addressLine2) {
            setErrors(prev => ({ ...prev, addressLine2: 'Street address is required' }));
            hasErrors = true;
        }
        if (!formData.addressLine3) {
            setErrors(prev => ({ ...prev, addressLine3: 'City is required' }));
            hasErrors = true;
        }
        if (!formData.pinCode) {
            setErrors(prev => ({ ...prev, pinCode: 'Pincode is required' }));
            hasErrors = true;
        } else if (formData.pinCode.length !== 6) {
            setErrors(prev => ({ ...prev, pinCode: 'Please enter a valid 6-digit pincode' }));
            hasErrors = true;
        }
        if (!addressType) {
            setErrors(prev => ({ ...prev, addressType: 'Please enter the address type' }));
            hasErrors = true;
        }
        if (!formData.latitude || !formData.longitude) {
            setErrors(prev => ({ ...prev, location: 'Please select a location on the map' }));
            hasErrors = true;
        }

        if (hasErrors) {
            return;
        }

        setIsSubmitting(true); // Start submission

        const token = localStorage.getItem('token');
        if (!token) {
            console.error('Token not found in localStorage');
            toast.error('Session expired. Please log in again.');
            navigate('/');
            return;
        }

        // Fetch existing addresses
        let existingAddresses: any[] = [];
        try {
            const response = await fetch('https://pamsapi.vofoxsolutions.com/api/address/ViewAllAddedAddressByUserAsync'
                , {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });

            if (response.ok) {
                existingAddresses = await response.json();
            } else {
                if (response.status === 401) {
                    toast.error('Session expired or unauthorized. Please log in again.');
                    navigate('/'); // Redirect to login page
                } else if (response.status !== 404) {
                    // toast.error('Failed to fetch addresses. Please try again.');
                }
                return;
            }
        } catch (error) {
            console.error('Error fetching addresses:', error);
            // toast.error('An unexpected error occurred. Please try again.');
            return;
        }

        // Check if the address already exists based on latitude and longitude
        // const duplicateAddress = existingAddresses.find(
        //     (address: any) =>
        //         address.latitude === formData.latitude && address.longitude === formData.longitude
        // );

        // if (duplicateAddress) {
        //     toast.error('Address already exists');
        //     return;
        // }

        const apiUrl = 'https://pamsapi.vofoxsolutions.com/api/address/AddNewAddressAsync';

        const payload = {
            email: formData.email || null, // Null if no email
            phoneNumber: formData.phoneNumber || null, // Null if no phone number
            addressLine1: formData.addressLine1,
            addressLine2: formData.addressLine2,
            addressLine3: formData.addressLine3,
            pamCode: formData.pinCode + formData.blockCode, // Combine pinCode and blockCode to form pamCode            latitude: formData.latitude,
            longitude: formData.longitude,
            latitude: formData.latitude,
            addressType: addressType, // Include the addressType here

        };
        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                const result = await response.json();
                if (result.isActualPincodeSelected === false) {
                    toast.info('The selected pincode differs from the recommended one.');
                }
                setFormData({
                    email: '',
                    phoneNumber: '',
                    addressLine1: '',
                    addressLine2: '',
                    addressLine3: '',
                    pinCode: '',
                    latitude: '',
                    longitude: '',
                    blockCode: ''
                });
                navigate(`/address-details/${result.id}`); // Use the ID from the API response
            } else {
                const errorData = await response.json();
                console.error('Error saving address:', errorData);
                toast.error('Failed to save address');
            }
        } catch (error) {
            console.error('Error saving address:', error);
            toast.error('This pincode is not supported');
        } finally {
            setIsSubmitting(false); // Reset submission state
        }
    };

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };
    useEffect(() => {
        const storedUserName = localStorage.getItem('userName');
        // console.log('Retrieved UserName from localStorage:', storedUserName); // Check what is retrieved
        if (storedUserName) {
            setUserName(storedUserName);
        }
        const handleStorageChange = () => {
            const updatedUserName = localStorage.getItem('userName');
            if (updatedUserName) {
                setUserName(updatedUserName);

            }
        };
        window.addEventListener('storage', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);

        };
    }, []);
    const fetchUserProfile = async () => {
        const token = localStorage.getItem("token"); // Get the stored token
        if (!token) {
            console.error('Token not found in localStorage');
            navigate('/home'); // Redirect to login page
            return; // Stop execution if token is not found
        }

        try {
            // console.log('Fetching user profile...');
            // console.log('Token:', token); // Log the token for debugging

            const response = await fetch('https://pamsapi.vofoxsolutions.com/api/User/GetUserProfile', {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${token}`, // Add token to Authorization header
                    "Content-Type": "application/json", // Ensure Content-Type is set
                },
            });

            // console.log('Response Status:', response.status); // Log the response status

            if (!response.ok) {
                throw new Error(`Failed to fetch user profile: ${response.status} ${response.statusText}`);
            }

            const data: UserProfile = await response.json();
            // console.log('Fetched User Profile:', data); // Log the fetched user profile
            setUserProfile(data); // Save user profile to state
            setUserName(data.userName); // Update the username state
            updateUserName(data.userName); // Update the username in the parent component

            setIsProfileModalOpen(false); // Open the profile modal

            // Pass user profile data via navigate to profile page
            navigate('/profile', {
                state: {
                    userName: data.userName,
                    email: data.email,
                    phoneNumber: data.phoneNumber,
                },
            });
        } catch (error) {
            console.error('Error fetching user profile:', error);
            toast.error("An error occurred while fetching user profile.");
        }
    };
    const handleLogout = () => {
        // Clear user session (localStorage, sessionStorage, or cookies)
        localStorage.removeItem('userToken'); // Example: remove the user token or session info
        sessionStorage.clear(); // Clear sessionStorage if needed
        // You can also clear cookies if used for session management

        // Redirect to the Register page
        navigate('/'); // Redirects to localhost:3000/register
    };

    useEffect(() => {
        // This will trigger whenever `componentKey` changes
    }, [componentKey]);

    return (
        <div className="flex h-screen bg-slate-100 ">
            {/* <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                limit={1}
                theme="light"
            /> */}
            <div className="flex flex-col flex-1  overflow-x-hidden overflow-y-auto">
                <header className="flex items-center justify-between px-6 py-3 bg-white">
                    <div className="flex items-center">
                        <button
                            onClick={() => setSidebarOpen(true)}
                            className="text-gray-500 focus:outline-none lg:hidden"
                        >
                            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M4 6H20M4 12H20M4 18H11"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                ></path>
                            </svg>
                        </button>
                    </div>

                    <div className="flex items-center">


                        <div className="relative m-3">
                            <button
                                onClick={toggleDropdown}
                                className="relative border border-whitesmoke focus:outline-none flex rounded-full h-12 items-center px-2 gap-2"
                            >
                                <div className="w-8 h-8 overflow-hidden rounded-full">
                                    <img
                                        className="object-cover w-full h-full"
                                        src="https://cdn-icons-png.flaticon.com/128/18573/18573514.png"
                                        alt="User Avatar"
                                    />
                                </div>
                                <h1>{userName || 'Guest'}</h1>          </button>

                            {dropdownOpen && (
                                <>
                                    {/* Close dropdown when clicking outside */}
                                    <div
                                        onClick={() => setDropdownOpen(false)}
                                        className="fixed inset-0 z-10 w-full h-full"
                                    ></div>

                                    {/* Dropdown menu */}
                                    <div className="absolute right-0 z-20 w-48 mt-2 bg-white rounded-md shadow-xl">
                                        <button
                                            onClick={fetchUserProfile}
                                            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
                                        >
                                            Profile
                                        </button>
                                        {/* <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white">
                  Products
                </a> */}
                                        <button
                                            onClick={handleLogout}
                                            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
                                        >
                                            Log out
                                        </button>              </div>
                                </>
                            )}
                        </div>
                    </div>
                </header>
                <main className="flex-1">
                    <div className="mt-4">

                        <div
                            className="relative ml-8 w-[95%] p-7 bg-indigo-100 rounded-md"
                            style={{
                                backgroundImage: `url(${Search})`,
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "left center",
                                backgroundSize: "auto 100%", // Adjusts the image to match container height
                            }}
                        >
                            <h1 className="text-base sm:text-lg text-dark font-semibold">
                                {/* Add New Address */}
                            </h1>
                        </div>
                        <div className="hidden lg:block absolute left-0 bottom-0">
                            <img src={Search} alt="Illustration" className="h-20" />
                        </div>
                        <div className="container px-4 py-4 mx-auto bg-white m-4 rounded-lg w-[95%] ">
                            {successMessage && (
                                <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4" role="alert">
                                    <strong className="font-bold">Success!</strong>
                                    <span className="block sm:inline ml-2">{successMessage}</span>
                                </div>
                            )}
                            {(
                                <span className="block sm:inline "></span>
                            )}
                            <div className="relative w-full h-map-height-50 mt-4">
                                <MapAddAddress key={componentKey} onLocationChange={handleLocationChange} />
                            </div>

                            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                <div>
                                    <label htmlFor="pinCode" className="block text-sm font-medium text-gray-700">
                                        Pincode <span className="text-red-500">*</span>
                                    </label>
                                    {/* <input
                                        type="text"
                                        id="pinCode"
                                        name="pinCode"
                                        placeholder="Enter 6-digit pincode"
                                        value={formData.pinCode}
                                        onChange={handlePinCodeChangeInput}
                                        maxLength={6}
                                        className={`w-full rounded-lg bg-slate-50 py-3 pl-6 pr-10 outline-none focus:border-blue focus-visible:shadow-none ${errors.pinCode ? 'border-red-500' : ''}`}
                                    /> */}
                                    <select
                                        id="pinCodeDropdown"
                                        name="pinCodeDropdown"
                                        value={formData.pinCode}
                                        onChange={handlePinCodeChangeSelect}
                                        className={`w-full rounded-lg bg-slate-50 py-3 pl-6 pr-10 outline-none focus:border-blue focus-visible:shadow-none ${errors.pinCode ? 'border-red-500' : ''}`}
                                    >
                                        {nearbyPinCodes.length > 0 && (
                                            <option value={nearbyPinCodes[0].pinCode}>
                                                {nearbyPinCodes[0].pinCode} (recommended)
                                            </option>
                                        )}
                                        {nearbyPinCodes.slice(1).map((pin, index) => (
                                            <option key={index + 1} value={pin.pinCode}>
                                                {pin.pinCode}
                                            </option>
                                        ))}
                                    </select>


                                    {errors.pinCode && (
                                        <p className="mt-1 text-sm text-red-500">{errors.pinCode}</p>
                                    )}
                                    <ToastContainer />
                                </div>
                                <div>
                                    <label htmlFor="addressLine1" className="block text-sm font-medium text-gray-700">
                                        Building/House Number <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Enter Building/House Number"
                                        maxLength={32}
                                        id="addressLine1"
                                        name="addressLine1"
                                        value={formData.addressLine1}
                                        onChange={handleInputChange}
                                        className={`w-full rounded-lg bg-slate-50 py-3 pl-6 pr-10 outline-none focus:border-blue focus-visible:shadow-none ${errors.addressLine1 ? 'border-red-500' : ''
                                            }`}
                                    />
                                    {errors.addressLine1 && (
                                        <p className="mt-1 text-sm text-red-500">{errors.addressLine1}</p>
                                    )}
                                </div>

                                <div>
                                    <label htmlFor="addressLine2" className="block text-sm font-medium text-gray-700">
                                        Street <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Enter Street"
                                        maxLength={32}

                                        id="addressLine2"
                                        name="addressLine2"
                                        value={formData.addressLine2}
                                        onChange={handleInputChange}
                                        className={`w-full rounded-lg bg-slate-50 py-3 pl-6 pr-10 outline-none focus:border-blue focus-visible:shadow-none ${errors.addressLine2 ? 'border-red-500' : ''
                                            }`}
                                    />
                                    {errors.addressLine2 && (
                                        <p className="mt-1 text-sm text-red-500">{errors.addressLine2}</p>
                                    )}
                                </div>
                                <div>
                                    <label htmlFor="addressLine3" className="block text-sm font-medium text-gray-700">
                                        City <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Enter City"
                                        maxLength={32}
                                        id="addressLine3"
                                        name="addressLine3"
                                        value={formData.addressLine3}
                                        onChange={handleInputChange}
                                        className={`w-full rounded-lg bg-slate-50 py-3 pl-6 pr-10 outline-none focus:border-blue focus-visible:shadow-none ${errors.addressLine3 ? 'border-red-500' : ''
                                            }`}
                                    />
                                    {errors.addressLine3 && (
                                        <p className="mt-1 text-sm text-red-500">{errors.addressLine3}</p>
                                    )}
                                </div>



                                <div>
                                    <label htmlFor="address" className="block text-sm font-medium text-gray-700">
                                        Save this Address as <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        id="address"
                                        name="address"
                                        className={`w-full rounded-lg bg-slate-50 py-3 pl-6 pr-10 outline-none focus:border-blue focus-visible:shadow-none ${errors.addressType ? 'border-red-500' : ''
                                            }`}
                                        value={isCustom ? "custom" : addressType} // Show "custom" when the custom option is selected
                                        onChange={handleAddressTypeChange}
                                        style={{ position: 'relative', zIndex: 1 }} // Ensure dropdown appears below
                                    >
                                        <option value="home">Home</option>
                                        <option value="office">Office</option>
                                        {/* <option value="business">Business</option> */}
                                        <option value="custom">Other (Type your own)</option>
                                    </select>

                                    {isCustom && (
                                        <input
                                            type="text"
                                            className={`mt-2 w-full rounded-lg bg-slate-50 py-2 pl-6 outline-none focus:border-blue focus-visible:shadow-none ${errors.addressType ? 'border-red-500' : ''
                                                }`}
                                            placeholder="Add Your Own Address Type"
                                            maxLength={15}
                                            value={addressType} // Bind the custom address type to the state
                                            onChange={handleCustomAddressTypeChange} // Update state when typing custom value
                                            style={{ position: 'relative', zIndex: 1 }} // Ensure input appears below
                                        />
                                    )}
                                    {errors.addressType && (
                                        <p className="mt-1 text-sm text-red-500">{errors.addressType}</p>
                                    )}
                                </div>


                                <div className="col-span-1 mt-5">
                                    <button
                                        className="flex items-center justify-center px-4 py-2 text-white rounded-md gap-2 min-w-[200px] h-[40px]
                                            shadow-lg hover:shadow-xl transition duration-200
                                            disabled:cursor-not-allowed
                                            disabled:bg-blue-600
                                            enabled:bg-[#3461FD]
                                            enabled:hover:bg-blue-700"
                                        onClick={handleSubmit}
                                        disabled={isSubmitting}
                                    >
                                        <span className="text-lg md:text-2xl">{isSubmitting ? <span ></span> : <span>+</span>}</span>
                                        <span className="sm:inline-block text-xs md:text-xs whitespace-nowrap">
                                            {isSubmitting ? 'SAVING...' : 'SAVE THIS ADDRESS'}
                                        </span>
                                    </button>
                                </div>



                                <div>
                                    {/* <label htmlFor="latitude" className="block text-sm font-medium text-gray-700">
                                        Latitude
                                    </label>
                                    <input
                                        type="text"
                                        id="latitude"
                                        name="latitude"
                                        value={formData.latitude}
                                        onChange={handleInputChange}
                                        className="w-full rounded-lg bg-slate-50 py-3 pl-6 pr-10 outline-none focus:border-blue"
                                    /> */}

                                    <div className="flex items-center">
                                        <label htmlFor="latitude" className="text-sm font-medium text-gray-700 mr-2">
                                            Latitude:
                                        </label>
                                        <span className="text-xs text-gray-500">{formData.latitude || "N/A"}</span>
                                    </div>


                                </div>
                                <div>
                                    {/* <label htmlFor="longitude" className="block text-sm font-medium text-gray-700">
                                        Longitude
                                    </label>
                                    <input
                                        type="text"
                                        id="longitude"
                                        name="longitude"
                                        value={formData.longitude}
                                        onChange={handleInputChange}
                                        className="w-full rounded-lg bg-slate-50 py-3 pl-6 pr-10 outline-none focus:border-blue"
                                    /> */}

                                    <div className="flex items-center">
                                        <label htmlFor="longitude" className="text-sm font-medium text-gray-700 mr-2">
                                            Longitude:
                                        </label>
                                        <span className="text-xs text-gray-500">{formData.longitude || "N/A"}</span>
                                    </div>

                                </div>

                            </div>




                        </div>
                    </div>
                </main>




                <div className="w-[96%] ml-6">
                    <div className="px-6 py-6 bg-white shadow-shadow1 rounded-md">
                        <p className="text-center text-jetgrey text-sm">GET ME THERE. © 2024</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Add this skeleton loader component
const AddNewAddressSkeleton = () => (
    <div className="w-full p-6 bg-white rounded-lg shadow-md animate-pulse">
        {/* Map Skeleton */}
        <div className="h-[400px] bg-gray-200 rounded-lg mb-6"></div>

        {/* Form Fields */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Building/House Number */}
            <div>
                <div className="h-4 w-32 bg-gray-200 rounded mb-2"></div>
                <div className="h-10 w-full bg-gray-200 rounded"></div>
            </div>

            {/* Street */}
            <div>
                <div className="h-4 w-20 bg-gray-200 rounded mb-2"></div>
                <div className="h-10 w-full bg-gray-200 rounded"></div>
            </div>

            {/* City */}
            <div>
                <div className="h-4 w-16 bg-gray-200 rounded mb-2"></div>
                <div className="h-10 w-full bg-gray-200 rounded"></div>
            </div>

            {/* Pincode */}
            <div>
                <div className="h-4 w-24 bg-gray-200 rounded mb-2"></div>
                <div className="h-10 w-full bg-gray-200 rounded"></div>
            </div>

            {/* Address Type */}
            <div>
                <div className="h-4 w-40 bg-gray-200 rounded mb-2"></div>
                <div className="h-10 w-full bg-gray-200 rounded"></div>
            </div>
        </div>

        {/* Submit Button */}
        <div className="flex justify-end mt-6">
            <div className="h-10 w-40 bg-gray-200 rounded"></div>
        </div>
    </div>
);

export default AddNewAddress;
